export const UNIT_TYPE_LIMIT = { 0: 3, 1: 10, 2: 10, 3: 10, 4: 10 }

export const UNIT_TYPE_NAME = {
  0: '企事业单位',
  1: '政府单位',
  2: '工业园区',
  3: '饮用水源地',
  4: '其他专项'
}

export function normalizeCountByType(raw) {
  const counts = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 }
  if (!raw || typeof raw !== 'object') {
    return counts
  }
  for (let t = 0; t <= 4; t++) {
    const key = String(t)
    const val = raw[t] != null ? raw[t] : raw[key]
    counts[t] = val != null ? Number(val) : 0
  }
  return counts
}

export function isTypeAtLimit(countByType, type) {
  const t = Number(type)
  const limit = UNIT_TYPE_LIMIT[t]
  if (limit == null) {
    return false
  }
  return (countByType[t] || 0) >= limit
}

export function limitMessage(type) {
  const t = Number(type)
  const limit = UNIT_TYPE_LIMIT[t]
  const name = UNIT_TYPE_NAME[t] || '该类型'
  return `每个账号最多添加 ${limit} 家${name}`
}



// WEBPACK FOOTER //
// ./src/data/basic/plan/unitLimit.js